export default {"src":"/_next/static/media/hexwrench_40.b21f6c1d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};